
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {map, catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TokenInterceptor } from 'app/authorized-http.service';
import { UtilsService } from 'app/services/utils.service';
import { NewsletterResource } from 'app/models/NewsletterResource';
import { TagListResource } from "app/models/TagListResource";
import { HttpClient } from "@angular/common/http";
import { environment } from "app/baseUrl";

@Injectable()
export class NewsletterAddSubscriberService {

  constructor(private httpa: TokenInterceptor,private http: HttpClient, private utilsService: UtilsService) { }

  saveSubscriber(url, body): Observable<NewsletterResource> {
    return this.http.post<NewsletterResource> (environment['url'] + url, body)
  }

  getAllTags(url): Observable<TagListResource> {
		return this.http.get<TagListResource> (environment['url'] + url)
	}

  getNewsletter(url): Observable<NewsletterResource> {
    return this.http.get<NewsletterResource>(environment['url'] + url)
  }
}
